import { render } from "./Koubei.vue?vue&type=template&id=080a10ae&ts=true"
import script from "./Koubei.vue?vue&type=script&lang=ts"
export * from "./Koubei.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__